import {useQuery} from 'react-query';
import {getSubProductsOfProducts} from 'services/farm/advertisement/add/subProductsOfProducts';

const useGetSubProducts = (guid: string) => {
  const {data, isLoading} = useQuery(
    ['sub-products', guid],
    getSubProductsOfProducts,
  );
  return {subProducts: data, isLoading};
};

export default useGetSubProducts;
